export default {
      id: "flag-united-states-of-america-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.e6637124.svg#flag-united-states-of-america",
      toString: function () {
        return this.url;
      }
    }